import type { Dayjs } from 'dayjs';

export type Range = [Dayjs, Dayjs];

/** Понедельник недели — независимо от локали dayjs (неделя склада — пн–вс). */
export function monday(d: Dayjs): Dayjs {
  return d.subtract((d.day() + 6) % 7, 'day').startOf('day');
}

export function lastWeek(today: Dayjs): Range {
  const start = monday(today).subtract(7, 'day');
  return [start, start.add(6, 'day')];
}

export function thisWeek(today: Dayjs): Range {
  return [monday(today), today.startOf('day')];
}

export function lastMonth(today: Dayjs): Range {
  const m = today.subtract(1, 'month');
  return [m.startOf('month'), m.endOf('month').startOf('day')];
}

export function thisMonth(today: Dayjs): Range {
  return [today.startOf('month'), today.startOf('day')];
}

export function yearToDate(today: Dayjs): Range {
  return [today.startOf('year'), today.startOf('day')];
}
